import React, { useState } from "react";
import { useAuth } from "../../AuthnContext";
import api from "../../api";

function NewLoginPage() {
  const { user, login, logout } = useAuth();

  const [isLogin, setIsLogin] = useState(true);
  const [loginData, setLoginData] = useState({ email: "", password: "", code: "" });
  const [registerData, setRegisterData] = useState({
    pesel: "",
    name: "",
    surname: "",
    email: ""
  });
  const [step, setStep] = useState(1); // Step 1: Login form, Step 2: Two-factor auth
  const [jwtToken, setJwtToken] = useState(null);
  const [refreshToken, setRefreshToken] = useState(null);
  const [isResetPassword, setIsResetPassword] = useState(false);
  const [resetEmail, setResetEmail] = useState("");

  const handleLoginChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleRegisterChange = (e) => {
    setRegisterData({ ...registerData, [e.target.name]: e.target.value });
  };

  const handleResetEmailChange = (e) => {
    setResetEmail(e.target.value);
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/Auth/prelogin", { username: loginData.email, password: loginData.password });
      setStep(2); // Move to two-factor authentication step
    } catch (error) {
      console.error("Login error:", error);
      alert("Błąd logowania... " + error.response.data);
    }
  };

  const handleTwoFactorSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post("/Auth/login", {
        username: loginData.email,
        password: loginData.password,
        twoFactorCode: loginData.code,
      });
      setJwtToken(response.data.jwtToken);
      setRefreshToken(response.data.refreshToken);
      login(response.data.jwtToken, response.data.refreshToken); // Store the token in context
      setLoginData({ email: "", password: "", code: "" }); // Clear login data
      setStep(1); // Reset to login step
    } catch (error) {
      console.error("Two-factor authentication error:", error);
      alert(error.response.data);
    }
  };

  const handleRegisterSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/Auth/patient", registerData);
      alert("Rejestracja pomyślna! Na podany adres email wysłany został link umożliwiający wygenerowanie hasła.");
      setIsLogin(true); // Switch back to login form
    } catch (error) {
      console.error("Registration error:", error);
      alert("Błąd rejestracji. Proszę sprawdzić dane.");
    }
  };

  const handlePasswordResetSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/Auth/request-password-reset", { email: resetEmail });
      alert("Link zmiany hasła wysłany! Proszę sprawdzić maila.");
      setIsResetPassword(false); // Close the reset password form
      setResetEmail(""); // Clear the email field
    } catch (error) {
      console.error("Password reset error:", error);
      alert("Błąd resetowania hasła. Proszę spróbować ponownie.");
    }
  };

  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <h3 className="card-title text-center">
                {isResetPassword ? "Resetuj Hasło" : isLogin ? "Zaloguj się" : "Zarejestruj się (Pacjenci)"}
              </h3>
              {isResetPassword ? (
                <form onSubmit={handlePasswordResetSubmit}>
                  <div className="mb-3">
                    <label htmlFor="resetEmail" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="resetEmail"
                      name="resetEmail"
                      value={resetEmail}
                      onChange={handleResetEmailChange}
                      required
                    />
                  </div>
                  <button type="submit" className="btn btn-primary w-100">Resetuj Hasło</button>
                  <div className="text-center mt-3">
                    <button
                      className="btn btn-link"
                      onClick={() => setIsResetPassword(false)}
                    >
                      Logowanie
                    </button>
                  </div>
                </form>
              ) : isLogin ? (
                step === 1 ? (
                  <form onSubmit={handleLoginSubmit}>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={loginData.email}
                        onChange={handleLoginChange}
                        required
                      />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">Hasło</label>
                      <div className="input-group">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control"
                          id="password"
                          name="password"
                          value={loginData.password}
                          onChange={handleLoginChange}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-outline-secondary"
                          onClick={() => setShowPassword((prev) => !prev)}
                          tabIndex={-1}
                        >
                          {showPassword ? "Ukryj" : "Pokaż"}
                        </button>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Zaloguj się</button>
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-link"
                        onClick={() => setIsResetPassword(true)}
                      >
                        Zresetuj hasło
                      </button>
                    </div>
                  </form>
                ) : (
                  <form onSubmit={handleTwoFactorSubmit}>
                    <div className="mb-3">
                      <br />
                      <p>Na twój adres e-mail wysłany został 6 cyfrowy kod potrzebny do autoryzacji logowania. Proszę wpisać go poniżej.</p>

                      <label htmlFor="code" className="form-label"><b>Kod Autoryzacji</b></label>
                      <input
                        type="text"
                        className="form-control"
                        id="code"
                        name="code"
                        value={loginData.code}
                        onChange={handleLoginChange}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Potwierdź kod</button>
                  </form>
                )
              ) : (
                <form onSubmit={handleRegisterSubmit}>
                  <div className="mb-3">
                    <label htmlFor="pesel" className="form-label">PESEL</label>
                    <input
                      type="text"
                      className="form-control"
                      id="pesel"
                      name="pesel"
                      value={registerData.pesel}
                      onChange={handleRegisterChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Imię</label>
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      name="name"
                      value={registerData.name}
                      onChange={handleRegisterChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="surname" className="form-label">Nazwisko</label>
                    <input
                      type="text"
                      className="form-control"
                      id="surname"
                      name="surname"
                      value={registerData.surname}
                      onChange={handleRegisterChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      name="email"
                      value={registerData.email}
                      onChange={handleRegisterChange}
                      required
                    />
                  </div>
                  <p>Po kliknięciu przycisku na podany adres e-mail zostanie wysłany link do strony, na której będzie można ustawić hasło do konta.</p>
                  <button type="submit" className="btn btn-primary w-100">Zarejestruj</button>
                </form>
              )}
              <div className="text-center mt-3">
                {!isResetPassword && (
                  <button
                    className="btn btn-link"
                    onClick={() => {
                      setIsLogin(!isLogin);
                      setStep(1); // Reset to step 1 when switching forms
                    }}
                  >
                    {isLogin ? "Nie masz konta pacjenta? Zarejestruj się" : "Posiadasz konto? Zaloguj się"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewLoginPage;